var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmptySavedItems = function SvgEmptySavedItems(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.213 74.0392C179.778 74.0392 182.668 71.2402 182.668 67.7874C182.668 64.3347 179.778 61.5356 176.213 61.5356C172.648 61.5356 169.758 64.3347 169.758 67.7874C169.758 71.2402 172.648 74.0392 176.213 74.0392Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74671 107.848C7.0921 107.848 8.99342 106.006 8.99342 103.735C8.99342 101.463 7.0921 99.6216 4.74671 99.6216C2.40132 99.6216 0.5 101.463 0.5 103.735C0.5 106.006 2.40132 107.848 4.74671 107.848Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2682 181.792C26.6136 181.792 28.5149 179.95 28.5149 177.679C28.5149 175.407 26.6136 173.566 24.2682 173.566C21.9228 173.566 20.0215 175.407 20.0215 177.679C20.0215 179.95 21.9228 181.792 24.2682 181.792Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9688 181.792L106.562 163.723V89.6396L46.9688 107.57V181.792Z",
    fill: "#B7BFCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166.155 181.792L106.562 163.723V89.6396L166.155 107.57V181.792Z",
    fill: "#6D7C9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9688 181.792L106.562 163.723V89.6396L46.9688 107.57V181.792Z",
    fill: "url(#paint0_linear_42016_46681)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.155 181.792L106.562 163.723V89.6396L166.155 107.57V181.792Z",
    fill: "url(#paint1_linear_42016_46681)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.562 200L46.9688 181.931V107.848L106.562 125.917V200Z",
    fill: "#EDF1F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.562 200L166.155 181.931V107.848L106.562 125.917V200Z",
    fill: "#DAE1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M93.0599 186.935L46.9688 181.931V107.848L106.562 125.917L93.0599 186.935Z",
    fill: "url(#paint2_linear_42016_46681)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.064 173.869L166.155 181.931V107.848L106.562 125.917L120.064 173.869Z",
    fill: "url(#paint3_linear_42016_46681)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.562 89.6397L78.5429 69.3467L17.9541 89.0837L46.9685 107.57L106.562 89.6397Z",
    fill: "#DAE1ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.562 89.6397L134.58 69.3467L195.169 89.0837L166.155 107.57L106.562 89.6397Z",
    fill: "#DAE1ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9685 107.848L106.562 125.917L76.8362 144.264L17.9541 125.361L46.9685 107.848Z",
    fill: "#EFF4FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.155 107.848L106.562 125.917L136.287 144.264L195.169 125.361L166.155 107.848Z",
    fill: "#EDF1F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.188 18.5169C131.537 40.4413 134.025 45.3128 134.842 66.9162C134.528 71.8475 134.333 77.2098 131.931 81.5277C128.722 88.133 120.874 92.7074 113.459 92.7815C105.82 92.9136 98.3314 88.3879 94.9607 81.4092C92.5892 77.1739 92.6647 71.3806 95.9176 67.5352C99.4541 63.8473 105.676 62.9277 110.151 65.2321C115.074 67.4204 118.012 71.9707 119.101 76.7695C120.189 81.5683 119.711 86.7732 118.382 91.5055C115.604 103.015 113.303 103.572 106.489 123.059",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.349 6.91223C133.33 10.1361 130.23 12.1101 126.298 11.0807C122.158 10.3978 119.228 9.69408 119.04 6.81676C119.135 3.86596 122.462 2.71106 126.356 1.40919C131.025 -0.38619 133.085 3.76188 133.349 6.91223Z",
    fill: "#DAE2EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 16.7709C108.698 18.8607 113.121 19.4701 115.277 16.2779C117.64 12.7392 119.663 10.1666 117.49 7.80366C115.392 5.7138 113.35 7.12081 108.681 8.91619C104.937 10.7641 104.143 14.4815 106.6 16.7709Z",
    fill: "#DAE2EB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.28 3.43534C118.19 2.64789 120.477 3.2256 121.498 4.71682C121.932 5.1894 122.442 5.93502 122.594 6.48108C124.219 10.1566 123.708 13.8004 121.515 14.6614C119.114 15.8688 115.806 13.7999 114.54 10.3239C114.238 9.23181 114.087 8.68574 113.86 7.86664C113.615 5.88192 114.371 4.2228 116.28 3.43534C116.28 3.43534 116.564 3.36185 116.28 3.43534Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5149 62.6016H24.8186V59.0249H21.6504V62.6016H17.9541V65.7696H21.6504V69.3463H24.8186V65.7696H28.5149V62.6016Z",
    fill: "url(#paint4_linear_42016_46681)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.634 152.34H32.9378V148.763H29.7695V152.34H26.0732V155.508H29.7695V159.085H32.9378V155.508H36.634V152.34Z",
    fill: "url(#paint5_linear_42016_46681)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.217 152.542L193.695 150.333L195.978 145.957L192.102 144.063L189.818 148.439L185.296 146.23L183.273 150.106L187.796 152.315L185.513 156.691L189.389 158.585L191.672 154.209L196.195 156.418L198.217 152.542Z",
    fill: "url(#paint6_linear_42016_46681)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42016_46681",
    x1: 87.7497,
    y1: 95.0051,
    x2: 80.1123,
    y2: 127.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42016_46681",
    x1: 87.7497,
    y1: 95.0051,
    x2: 80.1123,
    y2: 127.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_42016_46681",
    x1: 60.3292,
    y1: 158.55,
    x2: 73.8303,
    y2: 119.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_42016_46681",
    x1: 138.723,
    y1: 169.238,
    x2: 139.777,
    y2: 119.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_42016_46681",
    x1: 23.2353,
    y1: 59.3835,
    x2: 23.2353,
    y2: 65.1767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_42016_46681",
    x1: 31.3545,
    y1: 149.122,
    x2: 31.3545,
    y2: 154.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_42016_46681",
    x1: 193.812,
    y1: 145.449,
    x2: 190.304,
    y2: 152.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptySavedItems, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-saved-items.fa763333.svg";
export { ForwardRef as ReactComponent };